//
// Module for the Annual Summary Index view
//
rs.module("content/participant/member/annualsummary/index",

    ["controls/data/grid"],

    function (gridModule) {

        //
        // Initialize the module
        //
        function initialize(lrsGridApi, jsSelectors, cssClasses, ajaxUrl) {

            var filter = $.js(jsSelectors.filter);

            // Hook up click event on the radio buttons to reload the grid data via ajax
            filter.js(jsSelectors.annualIndicators).find("input").on('click', function () {

                filter.js(jsSelectors.loadingSpinner).show();

                gridModule.update(

                    ajaxUrl,
                    { annualIndicator: this.value },

                    lrsGridApi.agGridApi,

                    function done(gridUpdate) {
                        $.js(jsSelectors.calendarYearWarning).toggleClass(cssClasses.visible, !gridUpdate.context.limitsApplied);
                        filter.js(jsSelectors.loadingSpinner).hide();
                    }
                );
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);